/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CommandRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  commandRequestId?: string | null | undefined;
  command: string;
  args?: Array<string> | undefined;
  cwd?: string | null | undefined;
  env?: { [k: string]: string } | undefined;
  timeoutSeconds?: number | undefined;
};

/** @internal */
export const CommandRequest$inboundSchema: z.ZodType<
  CommandRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  command_request_id: z.nullable(z.string()).optional(),
  command: z.string(),
  args: z.array(z.string()).optional(),
  cwd: z.nullable(z.string()).optional(),
  env: z.record(z.string()).optional(),
  timeout_seconds: z.number().int().default(60),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "command_request_id": "commandRequestId",
    "timeout_seconds": "timeoutSeconds",
  });
});
/** @internal */
export type CommandRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  command_request_id?: string | null | undefined;
  command: string;
  args?: Array<string> | undefined;
  cwd?: string | null | undefined;
  env?: { [k: string]: string } | undefined;
  timeout_seconds: number;
};

/** @internal */
export const CommandRequest$outboundSchema: z.ZodType<
  CommandRequest$Outbound,
  z.ZodTypeDef,
  CommandRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  commandRequestId: z.nullable(z.string()).optional(),
  command: z.string(),
  args: z.array(z.string()).optional(),
  cwd: z.nullable(z.string()).optional(),
  env: z.record(z.string()).optional(),
  timeoutSeconds: z.number().int().default(60),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    commandRequestId: "command_request_id",
    timeoutSeconds: "timeout_seconds",
  });
});

export function commandRequestToJSON(commandRequest: CommandRequest): string {
  return JSON.stringify(CommandRequest$outboundSchema.parse(commandRequest));
}
export function commandRequestFromJSON(
  jsonString: string,
): SafeParseResult<CommandRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CommandRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CommandRequest' from JSON`,
  );
}
